import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ValueSection } from './components/ValueSection';
import { IndustriesSection } from './components/IndustriesSection';
import { ProgramsSection } from './components/ProgramsSection';
import { ResourcesSection } from './components/ResourcesSection';
import { TeamsSection } from './components/TeamsSection';
import { TrustSection } from './components/TrustSection';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-white text-charcoal" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ValueSection data-id="element-4" />
        <IndustriesSection data-id="element-5" />
        <ProgramsSection data-id="element-6" />
        <ResourcesSection data-id="element-7" />
        <TeamsSection data-id="element-8" />
        <TrustSection data-id="element-9" />
        <CTABanner data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}